import React, { useState, Fragment } from 'react'
import tw, { css, styled } from 'twin.macro'
import { cx } from '@emotion/css'
import qs from 'qs'
import { Dialog, Transition } from '@headlessui/react'
import PopUp from '../modal/forms'
import axios from 'axios'
import {
	StyledForm,
	FieldRow,
	FieldWrap,
	Helper,
	Button,
	Label,
} from '../form/styles'
import { Formik, Field } from 'formik'
import PropTypes from 'prop-types'
import * as Yup from 'yup'

const ContactModal = ({ subject, setSubject, showModal, setShowModal }) => {
	const initialValues = {
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		subject: subject || '',
		message: '',
	}

	const validationSchema = Yup.object().shape({
		firstName: Yup.string()
			.min(2, 'Too Short!')
			.max(50, 'Too Long!')
			.required('field is required'),
		lastName: Yup.string()
			.min(2, 'Too Short!')
			.max(50, 'Too Long!')
			.required('field is required'),
		email: Yup.string()
			.email('Invalid email')
			.required('field is required'),
		phone: Yup.string()
			.min(6, 'Too Short!')
			.max(11, 'Too Long!')
			.required('field is required'),
		subject: Yup.string().required('field is required'),
		message: Yup.string().required('field is required'),
	})

	const [submit, setSubmit] = useState(false)
	const [formStatus, setFormStatus] = useState(undefined)
	console.log('formStatus', formStatus)

	return (
		<>
			<Transition appear show={showModal} as={Fragment}>
				<Dialog
					aria-label="contact-modal"
					as="div"
					tw="fixed inset-0 z-[999999] overflow-y-auto"
					data-no-focus-lock
					open={showModal}
					onClose={() => {
						setSubject(null)
						setShowModal(false)
					}}
				>
					<div tw="mt-[40px] px-4 text-center">
						<Transition.Child
							as={Fragment}
							enter={cx(tw`ease-out duration-300`)}
							enterFrom={cx(tw`opacity-0`)}
							enterTo={cx(tw`opacity-100`)}
							leave={cx(tw`ease-in duration-200`)}
							leaveFrom={cx(tw`opacity-100`)}
							leaveTo={cx(tw`opacity-0`)}
						>
							<Dialog.Overlay tw="fixed inset-0 bg-black opacity-30" />
						</Transition.Child>
						<span tw="inline-block h-screen align-middle" aria-hidden="true">
							&#8203;
						</span>
						<Transition.Child
							as={Fragment}
							enter={cx(tw`ease-out duration-300`)}
							enterFrom={cx(tw`opacity-0 scale-95`)}
							enterTo={cx(tw`opacity-100 scale-100`)}
							leave={cx(tw`ease-in duration-200`)}
							leaveFrom={cx(tw`opacity-100 scale-100`)}
							leaveTo={cx(tw`opacity-0 scale-95`)}
						>
							<div tw="relative h-full z-10 md:mt-0 inline-block border border-4 border-blue-500  w-full max-w-lg p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
								{/* <Dialog.Title
									as="h3"
									tw="text-center text-xl font-display font-semibold leading-6 text-gray-900"
								>
									{subject}
								</Dialog.Title> */}
								<Formik
									initialValues={initialValues}
									validationSchema={validationSchema}
									onSubmit={async (values, { setSubmitting, resetForm }) => {
										setSubmitting(true)

										const url =
											'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8'
										const body = {
											origin: 'Pool Site Quote WebSite',
											orgid: '00D58000000JkgU',
											retURL:
												'https://maytronics.com.au/pool-site-quote/?form=contact',
											'00N4H00000E2wq9':
												'https://maytronics.com.au/pool-site-quote',
											name: `${values.firstName} ${values.lastName}`,
											subject: `Pool Site Quote - ${values.subject}`,
											email: values.email,
											phone: values.phone,
											description: values.message,
											recordType: '0124H0000006NyI', // Contact Us
										}

										try {
											await axios.post(url, qs.stringify(body))
										} catch (error) {
											console.log(error)
										} finally {
											setFormStatus('success')
											setSubject(true)
											setSubmit(true)
											setSubmitting(false)
											setShowModal(false)
										}
									}}
								>
									{({ isSubmitting, errors, touched }) => (
										<StyledForm css={tw`relative space-y-4`}>
											{/* First Name and Last Name Group Start */}
											<FieldRow>
												<FieldWrap width="1/2">
													<Label
														htmlFor="firstName"
														css={tw`capitalize font-bold mb-1`}
													>
														First Name
													</Label>
													<Input
														className="border-none"
														type="text"
														name="firstName"
														placeholder="First Name*"
														id="firstName"
														valid={
															!errors['firstName'] && touched['firstName']
																? 1
																: 0
														}
														invalid={
															errors['firstName'] && touched['firstName']
																? 1
																: 0
														}
													/>
													{touched['firstName'] && errors['firstName'] ? (
														<Helper>
															{`▲ ` +
																JSON.stringify(errors['firstName'], null, 2)}
														</Helper>
													) : (
														''
													)}
												</FieldWrap>
												<FieldWrap width="1/2">
													<Label
														htmlFor="lastName"
														css={tw`capitalize font-bold mb-1`}
													>
														Last Name
													</Label>
													<Input
														type="text"
														name="lastName"
														placeholder="Last Name*"
														id="lastName"
														valid={
															!errors['lastName'] && touched['lastName'] ? 1 : 0
														}
														invalid={
															errors['lastName'] && touched['lastName'] ? 1 : 0
														}
													/>
													{touched['lastName'] && errors['lastName'] ? (
														<Helper>
															{`▲ ` +
																JSON.stringify(errors['lastName'], null, 2)}
														</Helper>
													) : (
														''
													)}
												</FieldWrap>
											</FieldRow>
											{/* First Name and Last Name Group End */}

											{/* Email and Phone Group Start */}
											<FieldRow>
												<FieldWrap width="full">
													<Label
														htmlFor="email"
														css={tw`capitalize font-bold mb-1`}
													>
														Email
													</Label>
													<Input
														type="email"
														name="email"
														placeholder="Email*"
														id="email"
														valid={!errors['email'] && touched['email'] ? 1 : 0}
														invalid={
															errors['email'] && touched['email'] ? 1 : 0
														}
													/>
													{touched['email'] && errors['email'] ? (
														<Helper>
															{`▲ ` + JSON.stringify(errors['email'], null, 2)}
														</Helper>
													) : (
														''
													)}
												</FieldWrap>
											</FieldRow>

											<FieldRow>
												<FieldWrap width="full">
													<Label
														htmlFor="phone"
														css={tw`capitalize font-bold mb-1`}
													>
														Phone
													</Label>
													<Input
														type="tel"
														name="phone"
														placeholder="Phone*"
														id="phone"
														valid={!errors['phone'] && touched['phone'] ? 1 : 0}
														invalid={
															errors['phone'] && touched['phone'] ? 1 : 0
														}
													/>
													{touched['phone'] && errors['phone'] ? (
														<Helper>
															{`▲ ` + JSON.stringify(errors['phone'], null, 2)}
														</Helper>
													) : (
														''
													)}
												</FieldWrap>
											</FieldRow>
											{/* Email and Phone Group Start */}

											<FieldRow>
												<FieldWrap width="full">
													<Label
														htmlFor="subject"
														css={tw`capitalize font-bold mb-1`}
													>
														Subject
													</Label>
													<Input
														type="text"
														name="subject"
														placeholder="Subject*"
														value={subject}
														id="subject"
														onChange={e =>
															console.log('checkk >>', e.target.value)
														}
														disabled
														css={tw`bg-blue-500 text-white font-bold`}
														valid={
															!errors['subject'] && touched['subject'] ? 1 : 0
														}
														invalid={
															errors['subject'] && touched['subject'] ? 1 : 0
														}
													/>
													{touched['subject'] && errors['subject'] ? (
														<Helper>
															{`▲ ` +
																JSON.stringify(errors['subject'], null, 2)}
														</Helper>
													) : (
														''
													)}
												</FieldWrap>
											</FieldRow>

											{/* Message Group Start */}
											<FieldRow>
												<FieldWrap>
													<Label
														htmlFor="message`"
														css={tw`capitalize font-bold mb-1`}
													>
														Message
													</Label>
													<Textarea
														as="textarea"
														type="textarea"
														name="message"
														placeholder="Message*"
														id="message"
														valid={
															!errors['message'] && touched['message'] ? 1 : 0
														}
														invalid={
															errors['message'] && touched['message'] ? 1 : 0
														}
													/>
													{touched['message'] && errors['message'] ? (
														<Helper>
															{`▲ ` +
																JSON.stringify(errors['message'], null, 2)}
														</Helper>
													) : (
														''
													)}
												</FieldWrap>
											</FieldRow>
											{/* Message Group End */}

											<FieldRow>
												<FieldWrap width="1/2">
													<SubmitButton type="submit" disabled={isSubmitting}>
														{isSubmitting ? 'Submitting...' : 'Submit'}
													</SubmitButton>
												</FieldWrap>
											</FieldRow>
										</StyledForm>
									)}
								</Formik>
							</div>
						</Transition.Child>
					</div>
				</Dialog>
			</Transition>
			<PopUp
				showDialog={submit}
				close={() => setSubmit(false)}
				type={formStatus}
			/>
		</>
	)
}

const Input = styled(Field)`
	${tw`flex appearance-none w-full py-2 px-4 mb-3`}
	${tw`text-gray-700 leading-tight`}
	${tw`bg-gray-200`}
	${tw`focus:shadow-outline focus:outline-none`}
	${tw`rounded`}
	${({ valid }) => (valid ? tw`border-green-500` : ``)}
	${({ invalid }) => (invalid ? tw`border-red-500` : ``)}
	${({ minimalist }) => (minimalist ? tw`py-1 px-2` : undefined)}
	&::placeholder {
		${tw`text-gray-600`}
		${({ valid }) => (valid ? tw`text-green-500` : ``)}
		${({ invalid }) => (invalid ? tw`text-red-500` : ``)}
	}
	&[type="checkbox"] {
		${tw`ml-2`}
	}
	&[readonly] {
		${tw`bg-gray-500 border-gray-500 rounded`}
	}
	&:focus {
	box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.25);
		box-shadow: ${({ invalid }) =>
			invalid ? `0 0 0 3px rgba(246, 85, 34, 0.5)` : ``};
		box-shadow: ${({ valid }) => (valid ? `0 0 0 3px rgba(39, 174, 96, 0.5)` : ``)};
	}
`

const Textarea = styled(Field)`
	${tw`flex appearance-none w-full py-2 px-4 mb-3 h-32`}
	${tw`text-gray-700 leading-tight`}
	${tw`bg-gray-200`}
	${tw`focus:shadow-outline focus:outline-none`}
	${tw`rounded`}
	${({ valid }) => (valid ? tw`border-green-500` : ``)}
	${({ invalid }) => (invalid ? tw`border-red-500` : ``)}
	&::placeholder {
		${tw`text-gray-600`}
		${({ valid }) => (valid ? tw`text-green-500` : ``)}
		${({ invalid }) => (invalid ? tw`text-red-500` : ``)}
	}
	&:focus {
			box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.25);
		box-shadow: ${({ invalid }) =>
			invalid ? `0 0 0 3px rgba(246, 85, 34, 0.5)` : ``};
		box-shadow: ${({ valid }) => (valid ? `0 0 0 3px rgba(39, 174, 96, 0.5)` : ``)};
	}
`

export const SubmitButton = styled(Button)`
	${tw`bg-blue-500 w-full text-white font-bold py-3 hover:bg-blue-400`}
`

ContactModal.propTypes = {
	props: PropTypes.shape({
		subject: PropTypes.string,
		setSubject: PropTypes.func,
		showModal: PropTypes.bool,
		setShowModal: PropTypes.func,
	}),
}

export default ContactModal
